import { render, staticRenderFns } from "./SupplyRow.vue?vue&type=template&id=5822320c&scoped=true&lang=pug"
import script from "./SupplyRow.vue?vue&type=script&lang=js"
export * from "./SupplyRow.vue?vue&type=script&lang=js"
import style0 from "./SupplyRow.vue?vue&type=style&index=0&id=5822320c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5822320c",
  null
  
)

export default component.exports